import * as React from 'react';
import cx from 'classnames';

import './switch.styles.scss';

export type SwitchProps = {
	className?: string;
	checked?: boolean;
	onChange: (checked: boolean, e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Switch: React.FC<SwitchProps> = (props) => {
	const { className, checked, onChange, ...otherInputProps } = props;

	const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.checked, e);
	}, [onChange]);

	return (
		<label className={cx("Switch", className)}>
			<input {...otherInputProps} type="checkbox" checked={checked} onChange={handleChange} />
			<span className="Switch__slider"></span>
		</label>
	);
};